import styled, { keyframes } from "styled-components";

const bounceIn = keyframes`
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  60% {
    transform: translateY(5px);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
  }
`;

export const ConsolePageDropDownTriggerElementContainer = styled.div`
  display: flex;
  gap: 1rem;

  :hover:not(:disabled) {
    cursor: pointer;
  }

  svg path {
    color: ${({ theme }) => theme.console.pageTitleColor};
  }
`;

interface IConsolePageDropDownContentProps {
  show: boolean;
  shouldReverse?: boolean;
}
export const ConsolePageDropDownContent = styled.div<IConsolePageDropDownContentProps>`
  max-height: ${({ show }) => (show ? "fit-content" : "0")};
  opacity: ${({ show }) => (show ? 1 : 0)};
  transform: ${({ show }) => (show ? "translateY(0)" : "translateY(-10px)")};
  pointer-events: ${({ show }) => (show ? "all" : "none")};
  z-index: ${({ show }) => (show ? 1 : -1)};
  transition: max-height 0.3s ease, opacity 0 ease, transform 0.2s ease;

  margin-top: ${({ show, shouldReverse }) =>
    show && !shouldReverse ? "1rem" : "0"};

  margin-bottom: ${({ show, shouldReverse }) =>
    show && shouldReverse ? "1rem" : "0"};
`;

interface IConsolePageDropDownContainerProps {
  show: boolean;
  shouldReverse?: boolean;
}
export const ConsolePageDropDownContainer = styled.div<IConsolePageDropDownContainerProps>`
  display: flex;

  flex-direction: ${({ shouldReverse }) =>
    shouldReverse ? "column-reverse" : "column"};

  .console-page-dropdown-arrow {
    transition: transform 0.2s ease;
    transform: ${({ show }) => (show ? "rotate(180deg)" : "rotate(0deg)")};
  }

  animation-name: ${({ show }) => (show ? bounceIn : "unset")};
  animation-duration: 0.4s;
  animation-direction: forwards;
`;
